var splides = document.querySelectorAll('.splide');
// 1. query slider elements: are there any splide elements?
if(splides.length){
    // 2. process all instances
    for(var i=0; i<splides.length; i++){
        var splideElement = splides[i];
        //3.1 if no options are defined by 'data-splide' attribute: take these default options
        var splideDefaultOptions =
        {
            type   : 'slide',
            rewind: true,
            perPage: 1,
            autoplay: false,
            arrows: false,
            pagination:true,
            drag:true,
            keyboard:true,
            cover: true,
        }
        /**
        * 3.2 if options are defined by 'data-splide' attribute: default options will we overridden
        * see documentation: https://splidejs.com/guides/options/#by-data-attribute
        **/

        var splide = new Splide( splideElement, splideDefaultOptions );


        splide.on('active', function(slide) {
            if( !slide.isClone ){
                splideElement.querySelector('.paginations .current').textContent = slide.index + 1;
            }

        });

        // 3. mount/initialize this slider
        splide.mount();
    }
}

let cc_nav = document.querySelectorAll('.cc__withsubmenu');
let cc_navclose = document.querySelectorAll('.cc__close');

cc_nav.forEach(items => {
    items.addEventListener('click', (e)=>{
        let target = e.currentTarget.dataset.openmenu;
        let parentMenu = document.querySelector('.cc__nav-menu-content');

        parentMenu.classList.add('cc__submenu-open');
        if( parentMenu.classList.contains('cc__menuanimation') ){
            parentMenu.classList.remove('cc__menuanimation');
        }


        document.getElementById(target).classList.add('cc__submenus-open');
    });
});


cc_navclose.forEach(items => {
    items.addEventListener('click', (e)=>{
        let target = e.currentTarget.dataset.close;
        let parentMenu = document.querySelector('.cc__nav-menu-content');

        parentMenu.classList.remove('cc__submenu-open');
        if( !parentMenu.classList.contains('cc__menuanimation') ){
            parentMenu.classList.add('cc__menuanimation');
        }

        document.getElementById(target).classList.remove('cc__submenus-open');
    });
});

let sidedrawerbtn = document.querySelectorAll(".cc__sidedrawertrigger");
let sidedrawerbtnclose = document.querySelectorAll(".cc__sidedrawerclose");

sidedrawerbtn.forEach(sdo=>{
    sdo.addEventListener("click", (evt) => {
        let target = evt.currentTarget.dataset.target;

        document.getElementById(target).classList.add("sidedraweractive");
        document.body.style.setProperty('overflow', 'hidden');
    });
});


sidedrawerbtnclose.forEach(sdc=>{
    sdc.addEventListener("click", (evt) => {
        let target = evt.currentTarget.dataset.close;

        document.getElementById(target).classList.remove("sidedraweractive");
        document.body.style.removeProperty("overflow");
    });
});